export const LinkConstants = {
  disclosures: "https://getchallenger.com/disclosures",
  passwordReset: `${process.env.REACT_APP_BACKEND_URL}/onboarding/password_reset`,
  referralTermOfServices:
    "https://www.getchallenger.com/referral-reward-and-sign-up-bonus-terms-and-conditions",
};
